import { render, staticRenderFns } from "./CountryAdd.vue?vue&type=template&id=83acdaa4"
import script from "./CountryAdd.vue?vue&type=script&lang=js"
export * from "./CountryAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports